module.exports = __webpack_public_path__ + "img/004-validate.e094e45b.svg";